import React from 'react'
import { Switch, Route } from "react-router-dom"
import Locations from './locations.page'
import Create from './create/create.page'
import Edit from './edit/edit.page'

const LocationController = () => {
    return (
        <div className="location">
            <Switch>
                <Route path="/internet/locations/create" component={Create} />
                <Route path="/internet/locations/all" component={Locations} />
                <Route path="/internet/locations/:id" component={Edit} />
            </Switch>
        </div>
    )
}

export default LocationController